import { render, staticRenderFns } from "./WebWidgetCreate.vue?vue&type=template&id=6a635a58&scoped=true&"
import script from "./WebWidgetCreate.vue?vue&type=script&lang=js&"
export * from "./WebWidgetCreate.vue?vue&type=script&lang=js&"
import style0 from "./WebWidgetCreate.vue?vue&type=style&index=0&id=6a635a58&prod&lang=scss&scoped=true&"
import style1 from "./WebWidgetCreate.vue?vue&type=style&index=1&id=6a635a58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a635a58",
  null
  
)

export default component.exports